// @owner ClientPlatform

export type TextVariant =
  /** Display */
  | 'display-bold'

  /** Title */
  | 'title-semibold'
  | 'title-bold'

  /** Title Small */
  | 'title-small-semibold'
  | 'title-small-bold'

  /** Subtitle */
  | 'subtitle-medium'
  | 'subtitle-semibold'
  | 'subtitle-bold'

  /** Subtitle Small */
  | 'subtitle-small-medium'
  | 'subtitle-small-semibold'
  | 'subtitle-small-bold'

  /** Body */
  | 'body-regular'
  | 'body-medium'
  | 'body-semibold'
  | 'body-bold'

  /** Body Small */
  | 'body-small-regular'
  | 'body-small-medium'
  | 'body-small-semibold'
  | 'body-small-bold'

  /** Caption */
  | 'caption-regular'
  | 'caption-medium'
  | 'caption-semibold'

  /** Caption Small */
  | 'caption-small-regular'
  | 'caption-small-semibold'

  /** Code */
  | 'code-regular';

interface TextStyleDefinition {
  fontSize: string;
  lineHeight: string;
  fontWeight: number;
}

export const textStyles: Record<TextVariant, TextStyleDefinition> = {
  /** Display */
  'display-bold': {fontSize: '32px', lineHeight: '40px', fontWeight: 700},

  /** Title */
  'title-semibold': {fontSize: '24px', lineHeight: '32px', fontWeight: 600},
  'title-bold': {fontSize: '24px', lineHeight: '32px', fontWeight: 700},

  /** Title Small */
  'title-small-semibold': {fontSize: '18px', lineHeight: '28px', fontWeight: 600},
  'title-small-bold': {fontSize: '18px', lineHeight: '28px', fontWeight: 700},

  /** Subtitle */
  'subtitle-medium': {fontSize: '16px', lineHeight: '24px', fontWeight: 500},
  'subtitle-semibold': {fontSize: '16px', lineHeight: '24px', fontWeight: 600},
  'subtitle-bold': {fontSize: '16px', lineHeight: '24px', fontWeight: 700},

  /** Subtitle Small */
  'subtitle-small-medium': {fontSize: '14px', lineHeight: '20px', fontWeight: 500},
  'subtitle-small-semibold': {fontSize: '14px', lineHeight: '20px', fontWeight: 600},
  'subtitle-small-bold': {fontSize: '14px', lineHeight: '20px', fontWeight: 700},

  /** Body */
  'body-regular': {fontSize: '14px', lineHeight: '20px', fontWeight: 400},
  'body-medium': {fontSize: '14px', lineHeight: '20px', fontWeight: 500},
  'body-semibold': {fontSize: '14px', lineHeight: '20px', fontWeight: 600},
  'body-bold': {fontSize: '14px', lineHeight: '20px', fontWeight: 700},

  /** Body Small */
  'body-small-regular': {fontSize: '13px', lineHeight: '18px', fontWeight: 400},
  'body-small-medium': {fontSize: '13px', lineHeight: '18px', fontWeight: 500},
  'body-small-semibold': {fontSize: '13px', lineHeight: '18px', fontWeight: 600},
  'body-small-bold': {fontSize: '13px', lineHeight: '18px', fontWeight: 700},

  /** Caption */
  'caption-regular': {fontSize: '12px', lineHeight: '16px', fontWeight: 400},
  'caption-medium': {fontSize: '12px', lineHeight: '16px', fontWeight: 500},
  'caption-semibold': {fontSize: '12px', lineHeight: '16px', fontWeight: 600},

  /** Caption Small */
  'caption-small-regular': {fontSize: '10px', lineHeight: '12px', fontWeight: 400},
  'caption-small-semibold': {fontSize: '10px', lineHeight: '12px', fontWeight: 600},

  /** Code */
  'code-regular': {fontSize: '12px', lineHeight: '20px', fontWeight: 400},
};

export const textColors = {
  primary: 'var(--color-text-primary)',
  secondary: 'var(--color-text-secondary)',
  tertiary: 'var(--color-text-tertiary)',
  disabled: 'var(--color-text-disabled)',
};

export type TextColor = keyof typeof textColors;
